import CryptoJS from 'crypto-js';

const encryptToken = (token: string, key: string): string => {
  const encrypted = CryptoJS.AES.encrypt(token, key).toString();
  const encode = encodeURIComponent(encrypted);
  return encode;
};

export default encryptToken;
